const articlePublicationStatuses = {
	PUBLISHED: "published",
	NOT_PUBLISHED: "not_published",
	UNPUBLISHED: "unpublished",
	ANNOUNCED: "announced",
};

export default articlePublicationStatuses;
